import React from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { Form, FormGroup, Button } from 'reactstrap';
import Card from '@components//Card/Card';
import CustomControl from '@components/CustomControl/CustomControl';
import TwoFactorActivateBlock from '@components/TwoFactorAuth/TwoFactorActivateBlock';
import ChangePasswordBlock from '../../../../components/Password/ChangePasswordBlock';

import { authList } from '@components/TwoFactorAuth/twoFactorAuthHelpers';

import WithProfileNav from '../../hoc/withProfileNav';

const { SMS, GAUTH, TELEGRAM } = authList;

const SecurityPage = ({
  isLoading,
  isActivating,
  enableTwoFactorAuth,
  disableTwoFactorAuth,
  activateTwoFactorAuth,
  isActivateButtonRendering,
  isAuthMethodEnabled,
  responseInfo,
  two_factor,
  profile,
  onSubmit,
  showBotInfo,
  botsInfo,
}) => {
  const { sessionId, validTill, message, code } = responseInfo;
  return (
    <>
      <ChangePasswordBlock />
      <Card loading={isLoading} className="security-page">
        <Card.Body>
          <p className="security-page-title">
            <FormattedMessage
              id="pages.profile.security.description"
              defaultMessage="Two-factor authentication is an additional level of security for your account and financial transactions. Only you can access your account, even if someone else has learned your password."
            />
          </p>
          <p className="security-page-controls-title">
            <FormattedMessage
              id="pages.profile.security.controls.title"
              defaultMessage="Choose a verification method:"
            />
          </p>
          <Form>
            {/* <FormGroup>
            <CustomControl
              id={`two_factor_sms`}
              name="two_factor_sms"
              type="radio"
              className="custom-control-xs"
              value={1}
              onChange={enableTwoFactorAuth.bind(null, SMS)}
              checked={isAuthMethodEnabled(SMS)}
              disabled={two_factor.type === 2 && two_factor.is_active}
            >
              <FormattedMessage id="pages.profile.security.controls.sms" defaultMessage="Via SMS" />
            </CustomControl>
          </FormGroup> */}
            <FormGroup>
              <CustomControl
                id={`two_factor_gauth`}
                name="two_factor_gauth"
                type="radio"
                className="custom-control-xs"
                value={1}
                onChange={enableTwoFactorAuth.bind(null, GAUTH)}
                checked={isAuthMethodEnabled(GAUTH)}
                disabled={two_factor.type !== 2 && two_factor.is_active}
              >
                <FormattedMessage
                  id="pages.profile.security.controls.gauth"
                  defaultMessage="Via Google Auth"
                />
              </CustomControl>
            </FormGroup>

            <FormGroup>
              <CustomControl
                id={`two_factor_telegram`}
                name="two_factor_telegram"
                type="radio"
                className="custom-control-xs"
                value={1}
                onChange={enableTwoFactorAuth.bind(null, TELEGRAM)}
                checked={isAuthMethodEnabled(TELEGRAM)}
                disabled={two_factor.type !== 4 && two_factor.is_active}
              >
                <FormattedMessage
                  id="pages.profile.security.controls.telegram"
                  defaultMessage="Via Telegram"
                />
              </CustomControl>
            </FormGroup>

            {isActivateButtonRendering() && (
              <FormGroup className="security-page-button">
                <Button color="primary" type="button" onClick={activateTwoFactorAuth} size="sm">
                  <FormattedMessage
                    id="pages.profile.security.button.enable"
                    defaultMessage="Enable"
                  />
                </Button>
              </FormGroup>
            )}

            {two_factor.is_active === 1 && !isActivating && (
              <FormGroup className="security-page-button">
                <Button
                  color="primary"
                  type="button"
                  onClick={() => disableTwoFactorAuth()}
                  size="sm"
                >
                  <FormattedMessage
                    id="pages.profile.security.button.disable"
                    defaultMessage="Disable"
                  />
                </Button>
              </FormGroup>
            )}
          </Form>
        </Card.Body>

        {showBotInfo && (
          <Card.Body className="telegram-info">
            <FormattedHTMLMessage
              tagName="p"
              id="pages.profile.security.telegram.auth-err"
              values={botsInfo}
            />
          </Card.Body>
        )}

        {isActivating && (
          <Card.Body>
            <TwoFactorActivateBlock
              sessionId={sessionId}
              validTill={validTill}
              onSubmit={onSubmit}
              error={message}
              status={code}
              two_factor={two_factor}
              phone={profile.phone}
            />
          </Card.Body>
        )}
      </Card>
    </>
  );
};

export default WithProfileNav(SecurityPage);
